module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-lazyload"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Lazy Load")]), _vm._v(" "), _c('ul', {
    staticClass: "page-lazyload-list"
  }, _vm._l((_vm.list), function(item) {
    return _c('li', {
      staticClass: "page-lazyload-listitem"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item),
        expression: "item"
      }],
      staticClass: "page-lazyload-image"
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-768607c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/lazyload.vue
// module id = 307
// module chunks = 0